import { Form } from "@bleu.builders/ui";
import React from "react";
import { useRevalidator } from "react-router-dom";

import { useImpersonation } from "#/contexts/ImpersonationContext";
import { AdminPagePath } from "#/lib/pagesHelper";
import { client } from "#/utils/api-client";

export function ImpersonationBanner() {
  const { trueUser, currentUser } = useImpersonation();
  if (!trueUser || !currentUser) return null;
  if (trueUser?.email === currentUser?.email) return null;

  return (
    <div className="flex items-center gap-x-6 bg-primary px-6 py-2.5 sm:px-3.5 sm:before:flex-1">
      <p className="text-sm leading-6 text-white">
        <strong className="font-semibold">
          Logado como {currentUser.email}
        </strong>
        .{" "}
        <Form
          className="inline"
          action={AdminPagePath.STOP_IMPERSONATING}
          method="post"
        >
          <button type="submit">
            Clique aqui para voltar para {trueUser.email}{" "}
            <span aria-hidden="true">&rarr;</span>
          </button>
        </Form>
      </p>
      <div className="flex flex-1 justify-end"></div>
    </div>
  );
}
